<!-- version 1.2.0 -->
<!-- 2017年10月25日22:24:54 修复 value 为 null undefined 报错的问题 -->
<!-- 2017年11月8日11:41:54 增加事件监听 showmessage focus blur 保证大部分情况下文本编辑器内容的同步 -->
<!-- 2017-10-25 -->
<template>
  <div :id="vueUEditorId" :class="{ 'mc-editor-fullwidth': isFullWidth }">
    <VueUEditor class="editor-wrap" :ueditorPath="config.AjaxUrl + '/Content/Plug-in-unit/utf8-net/'" @ready="editorReady"></VueUEditor>
  </div>
</template>

<script>
// import $ from 'jquery'
// import tools from '@/components/common/tools'
import mc from '@/components/common/mc-lib'
import config from '@/components/common/config'

import VueUEditor from 'vue-ueditor'

export default {
  name: 'mcEditor',
  components: {
    VueUEditor
  },
  props: {
    isFullWidth: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      vueUEditorId: `vue_ueditor_${mc.Guid(20)}`,
      config: config,
      editorInstance: null,
      editorValue: this.value !== null && this.value !== undefined ? this.value : ''
    }
  },
  watch: {
    // 值变化
    value(newVal) {
      if (newVal === null || newVal === undefined) newVal = ''
      if (this.editorInstance) {
        if (newVal !== this.editorValue) {
          this.editorInstance.setContent(newVal)
        }
      } else {
        this.editorValue = newVal
      }
    }
  },
  methods: {
    editorReady(editorInstance) {
      editorInstance.setContent(this.editorValue)
      this.editorInstance = editorInstance
      editorInstance.addListener('contentChange showmessage focus blur', () => {
        let result = editorInstance.getContent()
        this.editorValue = result
        this.$emit('input', result)
      })
    },
    // 获取文本编辑器对象
    getEditorInstance() {
      return this.editorInstance
    },
    // 获取值
    getValue() {
      return this.editorInstance.getContent()
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";
.mc-editor-fullwidth {
  .edui-editor {
    width: 100% !important;
    .edui-editor-iframeholder {
      width: 100% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// mc-editor.vue?7e6474ac